import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from '../../../components/Select';

const EmployeeSelection = ({
  onSelect,
  employees,
  employeesById,
  selectedEmployeeId,
  employeesToDisableSelection,
  allowEmployeeSelection,
  ...props
}) => {
  // eslint-disable-next-line
  const [selectedEmployee, setSelectedEmployee] = useState(selectedEmployeeId ? { value: employeesById[selectedEmployeeId], label: employeesById[selectedEmployeeId].name } : null);

  const selectEmployee = employee => {
    if (allowEmployeeSelection) {
      setSelectedEmployee(employee);

      // bubble up if prop is present
      onSelect && onSelect(employee.value);
    }
  };

  const items = employees.map(employee => ({ value: employee, label: employee.name }));

  return (
    <Select
      label='Employee'
      placeholder='Select an employee'
      options={items}
      value={selectedEmployee}
      isDisabled={!allowEmployeeSelection}
      isOptionDisabled={option => employeesToDisableSelection[option.value.id] !== undefined}
      onChange={selectEmployee}
    />
  );
};

/**
 * `employeesToDisableSelection` is an object to allow for O(1) lookup instead of an array of ids which would be O(N)
 * probably won't see any difference but ¯\_(ツ)_/¯
 */
EmployeeSelection.propTypes = {
  onSelect: PropTypes.func,
  employeesToDisableSelection: PropTypes.shape({
    [PropTypes.number]: PropTypes.any
  }),
  allowEmployeeSelection: PropTypes.bool
};

function mapStateToProps (state) {
  return {
    employees: state.employees.employees,
    employeesById: state.employees.byId
  };
}

export default connect(mapStateToProps)(EmployeeSelection);
